/*
 * @Author: zhoupeng 
 * @Date: 2018-09-14 17:05:24 
 * @Last Modified by: 吴文洁
 * @Last Modified time: 2019-12-17 15:16:05
 */

<template>
  <div class="xm-video">
    <div
      :class="{
          'large-video':(size == 'large'),
          'middle-video':(size == 'middle'),
          'small-video':(size == 'small')
          }"
      @click="handlePlayVideo($event)"
    >
      <video :src="newVideoSrc" class="video" ref="video" v-if="!videoModalShow">
        <source :src="newVideoSrc" />Your browser does not support the video tag.
      </video>
      <img
        :src="newVideoSrc+'?x-oss-process=video/snapshot,t_1,m_fast'"
        alt
        class="video-first-pig"
      />
      <div class="play-icon-box">
        <img class="video-play-icon" src="../images/play.png" alt />
        <div class="video-time-bar" v-if="duration">
          <span class="video-time">{{formatDuration(duration)}}</span>
        </div>
      </div>
    </div>
    <div class="desc" v-if="wordStr">{{wordStr}}</div>
  </div>
</template>

<script>
import VideoUpload from "@/service/UploaderService";

export default {
  name: "xm-video",
  props: {
    videoSrc: {
      type: String,
      required: true
    },
    duration: {
      type: [String, Number],
      required: false
    },
    wordStr: {
      type: String,
      required: false
    },
    size: {
      type: String,
      required: false,
      default: "large"
    },
    download: {
      type: Boolean,
      default: false
    },
    ChangeCollectShow: {
      type: Function,
      required: false
    }
  },
  components: {
    //Example
  },

  data() {
    return {
      newVideoSrc: "",
      modalBg: false,
      videoModalShow: false
    };
  },

  watch: {
    videoSrc() {
      this.dealVideoParse();
    }
  },

  methods: {
    formatDuration(item) {
      let m = Math.floor((item / 1000 / 60) % 60);
      let s = Math.floor((item / 1000) % 60);
      if (m < 10) {
        m = "0" + m;
      }
      if (s < 10) {
        s = "0" + s;
      }
      return (item = m + ":" + s);
    },

    playModalVideo() {
      setTimeout(() => {
        this.modalVideo.play();
        setTimeout(() => {
          this.modalBg = true;
        }, 2000);
      }, 500);
    },

    handlePlayVideo(event) {
      // alert(navigator.userAgent.indexOf('iPad') > -1)
      if (this.size == "small") {
        event.preventDefault();
        event.stopPropagation();
      }

      const query = {
        url: this.newVideoSrc,
        title: document.title,
        download: this.download
      };
      if (query.url) {
        window.router.push({
          name: "video",
          query: query
        });
      }

      return;

      const video = this.$refs.video;
      if (video.requestFullScreen) {
        video.requestFullScreen();
        video.play();
      } else if (video.mozRequestFullScreen) {
        video.mozRequestFullScreen();
        video.play();
      } else if (video.webkitRequestFullScreen) {
        video.webkitRequestFullScreen();
        video.play();
      } else if (video.msRequestFullscreen) {
        video.msRequestFullscreen();
        video.play();
      } else if (video.oRequestFullscreen) {
        video.oRequestFullscreen();
        video.play();
      } else {
        const query = {
          url: this.newVideoSrc,
          title: document.title
        };
        window.router.push({
          name: "video",
          query: query
        });
      }

      video.addEventListener("webkitfullscreenchange", function(e) {
        if (!document.webkitIsFullScreen) {
          video.pause();
        }
      });
      video.play();
    },

    handleCloseVideo() {
      const modalVideo = this.$refs.modalVideo;
      modalVideo.pause();
      this.$emit("changeCollectShow", true);
      this.videoModalShow = false;
    },

    // video转码
    dealVideoParse() {
      VideoUpload.getVideoParseRoute(this.videoSrc).then(newVideo => {
        this.newVideoSrc = newVideo;
      });
    },

    scrollEvent() {
      const el = this.$el;
      const rect = el.getBoundingClientRect();
      if (
        rect.top !== 0 &&
        rect.top < document.documentElement.clientHeight &&
        !this.newVideoSrc
      ) {
        this.dealVideoParse();
      }
    }
  },

  mounted() {
    this.scrollEvent();
    if (document.querySelector(".comment-detail-scroll-page")) {
      document
        .querySelector(".comment-detail-scroll-page")
        .addEventListener(
          "scroll",
          window.throttle(this.scrollEvent.bind(this))
        );
    } else if (document.querySelector(".growth-index")) {
      document
        .querySelector(".xm-scroll")
        .addEventListener(
          "scroll",
          window.throttle(this.scrollEvent.bind(this))
        );
    } else {
      this.dealVideoParse();
    }
  }
};
</script>

<style lang='less'>
.wheat-toast-mask {
  .wheat-toast {
    z-index: 999999;
  }
}
.xm-video {
  width: 100%;
  height: 100%;
  .video {
    width: 0;
    height: 0;
    display: block;
  }
  .absolute {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .play-icon-box {
    .absolute;
    .video-play-icon {
      .absolute;
      margin: auto;
      display: block;
    }
  }

  .large-video {
    position: relative;
    background: #000;
    border-radius: 0.15rem;
    // margin: 0.15rem 0;

    .video-first-pig {
      display: block;
      height: 4.48rem;
      margin: auto;
      max-width: 100%;
      border-radius: 0.15rem;
    }
    
  }

  .middle-video {
    position: relative;
    border-radius: 0.1rem;
    width: 100%;
    height: 100%;

    img {
      object-fit: cover;
      border-radius: 0.1rem;
      width: 100%;
      height: 100%;
    }
    .play-icon-box {
      width: 100%;
      height: 100%;
      .video-play-icon {
        margin: auto;
        display: block;
        width: 0.7rem;
        height: 0.7rem;
      }
    }
  }

  .small-video {
    width: 100%;
    height: 100%;
    position: relative;
    .video-first-pig {
      width: 100%;
      height: 100%;
      border-radius: 0.1rem;
      z-index: -1;
      object-fit: cover;
    }

    .video-play-icon {
      width: 0.6rem;
      height: 0.6rem;
    }
  }

  .desc {
    margin-top: 0.1rem;
  }

  .video-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgb(0, 0, 0);
    z-index: 100000;
    .close {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0px;
      left: 0px;
      z-index: 1;
    }
    .video {
      position: absolute;
      width: 100%;
      height: 100%;
    }
  }
  .play-icon-box {
      .video-play-icon {
        width: 1rem;
        height: 1rem;
      }
      .video-time-bar {
        position: absolute;
        width: 100%;
        border-bottom-left-radius: 0.1rem;
        border-bottom-right-radius: 0.1rem;
        background: linear-gradient(
          180deg,
          rgba(238, 238, 238, 0),
          rgba(0, 0, 0, 0.5)
        );
        bottom: 0rem;
        right:0rem;
        line-height: 0.32rem;
        color: #fff;
        font-size: 0.22rem;
        .video-time {
          display: block;
          float: right;
          color: #fff;
          font-size: 0.22rem;
        }
      }
    }
}

</style>



// WEBPACK FOOTER //
// src/components/Video.vue